import { createGlobalStyle } from "styled-components";

import { color } from "./colors";
import { borderRadius, spacing } from "./spacing";
import { typography } from "./typography";

// Flatten nested color object into CSS variables
type NestedObject = { [key: string]: string | number | NestedObject };

const toCssVariables = (obj: NestedObject, prefix = ""): string =>
  Object.entries(obj)
    .map(([key, value]) =>
      typeof value === "object"
        ? toCssVariables(value, `${prefix}${key}-`)
        : `--${prefix}${key}: ${value};`
    )
    .join("\n");

export const GlobalStyle = createGlobalStyle`
  :root {
    ${toCssVariables(color)}
    ${toCssVariables(typography)}
    ${toCssVariables(spacing)}
    ${toCssVariables(borderRadius)}
  }
`;
